/*
 * @Author: 党方超
 * @Date: 2020-08-21 10:42:19
 * @LastEditTime: 2020-09-08 16:46:15
 * @LastEditors: Please set LastEditors
 * @Description: restful接口风格封装
 * @FilePath: /dmps-console-web/src/utils/restful.js
 */
import http from './http.js'

class Restful {
  constructor(project, model) {
    this.model = model
    this.project = project
  }

  // 查询列表
  get(data) {
    const url = this.project + this.model
    return http.get(url, data).then(res => {
      return res
    })
  }

  // 查询全部
  getAll(data) {
    const url = this.project + this.model + '/query'
    return http.get(url, data).then(res => {
      return res
    })
  }

  // 查询单个
  query(id, data = {}) {
    const url = this.project + this.model + '/' + id
    return http.get(url, data).then(res => {
      return res
    })
  }

  //新增
  add(data) {
    const url = this.project + this.model
    return http.post(url, data).then(res => {
      return res
    })
  }

  //修改
  edit(id, data) {
    const url = this.project + this.model + '/' + id
    return http.put(url, data).then(res => {
      return res
    })
  }

  // 批量删除
  batch(data) {
    const url = this.project + this.model
    return http.post(url, { ids: data.toString() }).then(res => {
      return res
    })
  }

  // 删除
  del(id, data) {
    const url = this.project + this.model + '/' + id
    return http.del(url, data).then(res => {
      return res
    })
  }

  // 排序
  setSort = function(data = []) {
    const url = this.project + this.model + '/sort'
    return http.put(url, data).then(res => {
      return res
    })
  }

  // 启用禁用
  setEnabled = function(id, enabled, data) {
    const url = this.project + this.model + '/enabled/' + id
    return http.put(url, Object.assign(data, { enabled })).then(res => {
      return res
    })
  }

  // 发布取消发布
  release = function(id, released, data) {
    const url = this.project + this.model + '/released/' + id
    return http.put(url, Object.assign(data, { released })).then(res => {
      return res
    })
  }

  // 发布取消发布
  batchRelease = function(data) {
    const url = this.project + this.model + '/released'
    return http.put(url, data).then(res => {
      return res
    })
  }

  export = (data = {}) => {
    const url = this.project + this.model + '/export'
    return http.octetget(url, data).then(res => {
      res.url = window.URL.createObjectURL(res.file)
      return res
    })
  }
}

export default Restful
